import React, { useEffect } from 'react';

import './FilterFields.scss';
import { Dropdown } from 'semantic-ui-react';
import { addModifiers } from '../../../../shared/helpers';
import { useFilterController } from '../useFilterForm';
import { UseFiltersControllerProps } from '../types';
import { getInputId } from './getInputId';

interface DropdownFieldProps {
  controllerProps: UseFiltersControllerProps;
  title: string;
  options: DropdownOption[];
  size?: 'small' | 'medium' | 'large';
  classModifier?: string;
}

interface DropdownOption {
  value: string;
  text: string;
}

export function DropdownField({ title, options, size = 'small', controllerProps, classModifier = '' }: DropdownFieldProps) {
  const controller = useFilterController(controllerProps);

  const onChange = (_: any, { value }: any) => {
    controller.field.onChange({ target: { value } });
    controllerProps.control.flushDebounce();
  };

  useEffect(() => {
    const isSelectedValueValid = options.find(option => option.value === controller.field.value);
    if (!isSelectedValueValid) {
      onChange(null, { value: options[0].value });
    }
  }, [onChange, options, controller.field.value]);

  const id = getInputId(controllerProps.name);
  return (
    <div className={`form__input ${addModifiers('dropdown-field', [classModifier])}`}>
      <label htmlFor={id} className="dropdown-field__title">
        {title}
      </label>
      <Dropdown
        labeled={true}
        id={id}
        data-testid={id}
        value={controller.field.value}
        className={`dropdown-custom ${addModifiers('data-explorer-filters__dropdown', [size, classModifier])}`}
        options={options}
        selection={true}
        onChange={onChange}
      />
    </div>
  );
}
